import store from "@/store";

const params = new URLSearchParams(window.location.search);
const primaryColor = params.get("primaryColor");
const accentColor = params.get("accentColor");

const setPrimaryCssVariable = (color) => {
  document.body.style.setProperty("--primary", color);
};

if (primaryColor && accentColor) {
  if (!primaryColor.includes("#") && primaryColor.length === 6) {
    store.dispatch("setPrimaryColor", "#".concat(primaryColor));
    setPrimaryCssVariable("#".concat(primaryColor));
  }
  if (!accentColor.includes("#") && accentColor.length === 6) {
    store.dispatch("setAccentColor", "#".concat(accentColor));
  }
}
